import { Image as ExpoImage } from 'expo-image'

import { useImageNative, type TImageProps } from './useImage'

export const Image = ({ ref, ...props }: TImageProps) => {
  const { getImgProps } = useImageNative({
    ...props,
    ref,
  })

  return <ExpoImage ref={ref} {...getImgProps()} />
}

Image.displayName = 'Image'
